import { useCallback } from 'react'
import { ReactFCC } from '@/types/react'
import { useTranslate } from '@/utils/translate/translate-client'
import { OptionGroup } from '../../components/OptionGroup'
import { TorchApplicationProductionType } from '../../components/TorchApplicationContext'

interface ProductionTypesProps {
  disabled?: boolean
  value?: TorchApplicationProductionType
  onChange: ({ name, value }: { name: string; value: string }) => void
  name: string
}

export const ProductionTypes: ReactFCC<ProductionTypesProps> = ({ disabled, name, value, onChange }) => {
  const { t } = useTranslate('guild-create')

  const options = [
    {
      label: t('movie', 'Movie'),
      value: TorchApplicationProductionType.Movie,
    },
    {
      label: t('series', 'Series'),
      value: TorchApplicationProductionType.Series,
    },
  ]

  const handleChange = useCallback(
    (value: string[]) => {
      const [productionTypeValue] = value
      onChange({ name, value: productionTypeValue ?? '' })
    },
    [name, onChange],
  )

  return (
    <OptionGroup
      name="productionType"
      label={t('productionType', 'Production Type')}
      options={options}
      required
      disabled={disabled}
      value={value ? [value] : []}
      onChange={handleChange}
      limit={1}
    />
  )
}
